import { Radio as MUIRadio, RadioProps } from "@mui/material";

export type CustomRadioProps = {
  circleColor?: string;
} & RadioProps;

function Radio({ circleColor, sx, checked, ...props }: CustomRadioProps) {
  return <MUIRadio checked={checked} {...props} sx={sx} />;
}

export default Radio;
